export default __webpack_public_path__ + "static/media/5.c44365f2.jpg";